// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"c1b44a02","118":"834a9c78","328":"a7521f0f","351":"fa52c41c","391":"0e5cb2cd","399":"67b4aa83","447":"8def6f59","519":"6fa2e58d","628":"84f60c65","773":"c6364ee0","835":"9ad9a5ab","839":"15232aa2"}[chunkId] + ".chunk.js";
};